import { useEffect } from "react";

import { useRouter } from "@medbillai/navigation/router";
import { Flag } from "@medbillai/utils";
import { homeUrl } from "@medbillai/utils/urls";

import { useBoolVariation } from "../../lib/flag";
import { useFlagHasIdentified } from "../../lib/flag/shared";

/** Every Coverage route sends a flag-off visit home. */
export function useCoverageTabGate() {
  const { replace } = useRouter();
  const coverageTab = useBoolVariation(Flag.COVERAGE_TAB, false);
  const hasIdentified = useFlagHasIdentified();
  useEffect(() => {
    if (hasIdentified && !coverageTab) {
      replace(homeUrl());
    }
  }, [hasIdentified, coverageTab, replace]);
}
